import React, {useEffect, useState} from 'react'
import {
  StyledTabs,
  StyledTabsList,
  StyledTabsTrigger,
  StyledTabsContent
} from '../../../src/components/Tabs/stories/StoryStyles'

const StyledTabsExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)
  useEffect(() => {
    setDomLoaded(true)
  }, [])

  return (
    <>
      {domLoaded && (
        <StyledTabs defaultValue="tab1" orientation="vertical">
          <StyledTabsList aria-label="tabs example">
            <StyledTabsTrigger value="tab1">One</StyledTabsTrigger>
            <StyledTabsTrigger value="tab2">Two</StyledTabsTrigger>
            <StyledTabsTrigger value="tab3">Three</StyledTabsTrigger>
          </StyledTabsList>
          <StyledTabsContent value="tab1">Tab one content</StyledTabsContent>
          <StyledTabsContent value="tab2">Tab two content</StyledTabsContent>
          <StyledTabsContent value="tab3">Tab three content</StyledTabsContent>
        </StyledTabs>
      )}
    </>
  )
}

export default StyledTabsExample
